export const workplaceSettingsConstants = {
  GET_WORKPLACE_LIST_REQUEST: 'WORKPLACESETTINGS/GET_WORKPLACE_LIST_REQUEST',
  GET_WORKPLACE_LIST_SUCCESS: 'WORKPLACESETTINGS/GET_WORKPLACE_LIST_SUCCESS',
  GET_WORKPLACE_LIST_FAILURE: 'WORKPLACESETTINGS/GET_WORKPLACE_LIST_FAILURE',

  GET_WORKPLACE_MANAGE_INVITES_REQUEST: 'WORKPLACESETTINGS/GET_WORKPLACE_MANAGE_INVITES_REQUEST',
  GET_WORKPLACE_MANAGE_INVITES_SUCCESS: 'WORKPLACESETTINGS/GET_WORKPLACE_MANAGE_INVITES_SUCCESS',
  GET_WORKPLACE_MANAGE_INVITES_FAILURE: 'WORKPLACESETTINGS/GET_WORKPLACE_MANAGE_INVITES_FAILURE',

  GET_WORKPLACE_SETTINGS_REQUEST: 'WORKPLACESETTINGS/GET_WORKPLACE_SETTINGS_REQUEST',
  GET_WORKPLACE_SETTINGS_SUCCESS: 'WORKPLACESETTINGS/GET_WORKPLACE_SETTINGS_SUCCESS',
  GET_WORKPLACE_SETTINGS_FAILURE: 'WORKPLACESETTINGS/GET_WORKPLACE_SETTINGS_FAILURE',

  UPDATE_WORKPLACE_REQUEST: 'WORKPLACESETTINGS/UPDATE_WORKPLACE_REQUEST',
  UPDATE_WORKPLACE_SUCCESS: 'WORKPLACESETTINGS/UPDATE_WORKPLACE_SUCCESS',
  UPDATE_WORKPLACE_FAILURE: 'WORKPLACESETTINGS/UPDATE_WORKPLACE_FAILURE',

  UPDATE_WORKPLACE_RIGHTS_AND_PERMISSIONS_REQUEST: 'WORKPLACESETTINGS/UPDATE_WORKPLACE_RIGHTS_AND_PERMISSIONS_REQUEST',
  UPDATE_WORKPLACE_RIGHTS_AND_PERMISSIONS_SUCCESS: 'WORKPLACESETTINGS/UPDATE_WORKPLACE_RIGHTS_AND_PERMISSIONS_SUCCESS',
  UPDATE_WORKPLACE_RIGHTS_AND_PERMISSIONS_FAILURE: 'WORKPLACESETTINGS/UPDATE_WORKPLACE_RIGHTS_AND_PERMISSIONS_FAILURE',

  GET_WORKPLACE_MEMBERS_REQUEST: 'WORKPLACESETTINGS/GET_WORKPLACE_MEMBERS_REQUEST',
  GET_WORKPLACE_MEMBERS_SUCCESS: 'WORKPLACESETTINGS/GET_WORKPLACE_MEMBERS_SUCCESS',
  GET_WORKPLACE_MEMBERS_FAILURE: 'WORKPLACESETTINGS/GET_WORKPLACE_MEMBERS_FAILURE',

  GET_WORKPLACE_SETTINGS_MEMBERS_REQUEST: 'WORKPLACESETTINGS/GET_WORKPLACE_SETTINGS_MEMBERS_REQUEST',
  GET_WORKPLACE_SETTINGS_MEMBERS_SUCCESS: 'WORKPLACESETTINGS/GET_WORKPLACE_SETTINGS_MEMBERS_SUCCESS',
  GET_WORKPLACE_SETTINGS_MEMBERS_FAILURE: 'WORKPLACESETTINGS/GET_WORKPLACE_SETTINGS_MEMBERS_FAILURE',

  GET_WORKPLACE_LEADERSHIP_TEAM_REQUEST: 'WORKPLACESETTINGS/GET_WORKPLACE_LEADERSHIP_TEAM_REQUEST',
  GET_WORKPLACE_LEADERSHIP_TEAM_SUCCESS: 'WORKPLACESETTINGS/GET_WORKPLACE_LEADERSHIP_TEAM_SUCCESS',
  GET_WORKPLACE_LEADERSHIP_TEAM_FAILURE: 'WORKPLACESETTINGS/GET_WORKPLACE_LEADERSHIP_TEAM_FAILURE',

  GET_WORKPLACE_MEMBERS_PAGINATION_REQUEST: 'WORKPLACESETTINGS/GET_WORKPLACE_MEMBERS_PAGINATION_REQUEST',
  GET_WORKPLACE_MEMBERS_PAGINATION_SUCCESS: 'WORKPLACESETTINGS/GET_WORKPLACE_MEMBERS_PAGINATION_SUCCESS',
  GET_WORKPLACE_MEMBERS_PAGINATION_FAILURE: 'WORKPLACESETTINGS/GET_WORKPLACE_MEMBERS_PAGINATION_FAILURE',

  GET_WORKPLACE_SETTINGS_MEMBERS_PAGINATION_REQUEST:
    'WORKPLACESETTINGS/GET_WORKPLACE_SETTINGS_MEMBERS_PAGINATION_REQUEST',
  GET_WORKPLACE_SETTINGS_MEMBERS_PAGINATION_SUCCESS:
    'WORKPLACESETTINGS/GET_WORKPLACE_SETTINGS_MEMBERS_PAGINATION_SUCCESS',
  GET_WORKPLACE_SETTINGS_MEMBERS_PAGINATION_FAILURE:
    'WORKPLACESETTINGS/GET_WORKPLACE_SETTINGS_MEMBERS_PAGINATION_FAILURE',

  ADD_WORKPLACE_MEMBER_ROLE_REQUEST: 'WORKPLACESETTINGS/ADD_WORKPLACE_MEMBER_ROLE_REQUEST',
  ADD_WORKPLACE_MEMBER_ROLE_SUCCESS: 'WORKPLACESETTINGS/ADD_WORKPLACE_MEMBER_ROLE_SUCCESS',
  ADD_WORKPLACE_MEMBER_ROLE_FAILURE: 'WORKPLACESETTINGS/ADD_WORKPLACE_MEMBER_ROLE_FAILURE',

  REMOVE_WORKPLACE_MEMBER_ROLE_REQUEST: 'WORKPLACESETTINGS/REMOVE_WORKPLACE_MEMBER_ROLE_REQUEST',
  REMOVE_WORKPLACE_MEMBER_ROLE_SUCCESS: 'WORKPLACESETTINGS/REMOVE_WORKPLACE_MEMBER_ROLE_SUCCESS',
  REMOVE_WORKPLACE_MEMBER_ROLE_FAILURE: 'WORKPLACESETTINGS/REMOVE_WORKPLACE_MEMBER_ROLE_FAILURE',

  REMOVE_WORKPLACE_MEMBER_REQUEST: 'WORKPLACESETTINGS/REMOVE_WORKPLACE_MEMBER_REQUEST',
  REMOVE_WORKPLACE_MEMBER_SUCCESS: 'WORKPLACESETTINGS/REMOVE_WORKPLACE_MEMBER_SUCCESS',
  REMOVE_WORKPLACE_MEMBER_FAILURE: 'WORKPLACESETTINGS/REMOVE_WORKPLACE_MEMBER_FAILURE',

  GET_WORKPLACE_GROUPS_REQUEST: 'WORKPLACESETTINGS/GET_WORKPLACE_GROUPS_REQUEST',
  GET_WORKPLACE_GROUPS_SUCCESS: 'WORKPLACESETTINGS/GET_WORKPLACE_GROUPS_SUCCESS',
  GET_WORKPLACE_GROUPS_FAILURE: 'WORKPLACESETTINGS/GET_WORKPLACE_GROUPS_FAILURE',

  GET_WORKPLACE_MEMBER_LED_GROUPS_REQUEST: 'WORKPLACESETTINGS/GET_WORKPLACE_MEMBER_LED_GROUPS_REQUEST',
  GET_WORKPLACE_MEMBER_LED_GROUPS_SUCCESS: 'WORKPLACESETTINGS/GET_WORKPLACE_MEMBER_LED_GROUPS_SUCCESS',
  GET_WORKPLACE_MEMBER_LED_GROUPS_FAILURE: 'WORKPLACESETTINGS/GET_WORKPLACE_MEMBER_LED_GROUPS_FAILURE',

  GET_RIGHTS_PERMISSIONS_REQUEST: 'WORKPLACESETTINGS/GET_RIGHTS_PERMISSIONS_REQUEST',
  GET_RIGHTS_PERMISSIONS_SUCCESS: 'WORKPLACESETTINGS/GET_RIGHTS_PERMISSIONS_SUCCESS',
  GET_RIGHTS_PERMISSIONS_FAILURE: 'WORKPLACESETTINGS/GET_RIGHTS_PERMISSIONS_FAILURE',

  DELETE_WORKPLACE_REQUEST: 'WORKPLACESETTINGS/DELETE_WORKPLACE_REQUEST',
  DELETE_WORKPLACE_SUCCESS: 'WORKPLACESETTINGS/DELETE_WORKPLACE_SUCCESS',
  DELETE_WORKPLACE_FAILURE: 'WORKPLACESETTINGS/DELETE_WORKPLACE_FAILURE',

  DELETE_WORKPLACE_INVITATION_REQUEST: 'WORKPLACESETTINGS/DELETE_WORKPLACE_INVITATION_REQUEST',
  DELETE_WORKPLACE_INVITATION_SUCCESS: 'WORKPLACESETTINGS/DELETE_WORKPLACE_INVITATION_SUCCESS',
  DELETE_WORKPLACE_INVITATION_FAILURE: 'WORKPLACESETTINGS/DELETE_WORKPLACE_INVITATION_FAILURE'
}
